export function getCurrentAnchor(): RegExpMatchArray | null {
  return String(window.location).match(window.regExes.urlAnchor);
}

export function _turnURLintoLink(string: string) {
  if (!string.includes("://")) {
    // return
  }
}
